<div class="update-overlay" *ngIf="showOverlay">
  <div class="update-overlay-box ats-pulse">
    <div *ngIf="appUpdate !== ''" class="content-pack-status">
      <div *ngIf="appUpdate === 'Checking'" class="status">
        <h1>{{ "pack-download.packStatusChecking" | i18next}}...</h1>
      </div>
      <div *ngIf="appUpdate === 'Downloading'" class="status">
        <h1>{{ "pack-download.packStatusDownloading" | i18next }}...</h1>
        <small>{{ "pack-download.packProgress" | i18next }} ({{ updateProgress }} %)</small>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" *ngIf="showOverlay"></div>
